export default "__VITE_ASSET__BPZyeZ2$__"